import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { useGetSingleCatalogQuery } from 'Services/ProductManagement/Features/Catalog/catalogApi'
import { SELECTED_CATALOG_PARAMETER_KEY } from 'Services/ProductManagement/Features/Catalog/Hooks/useCatalogsWithParams'
import TariffCatalogForm from 'Services/ProductManagement/Features/Tariff/Components/TariffCatalogForm'
import useSelectedTariff from 'Services/ProductManagement/Features/Tariff/Hooks/useSelectedTariff'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { IS_HSL_SERVICE_ENVIRONMENT, PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

function TariffCatalogEditPage() {
  const { id: tariffId, catalogId } = useParams()
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs/${tariffId}/sales-channels`
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_CATALOG_PARAMETER_KEY}=${catalogId}`
  )
  const { data: singleCatalog, isLoading } = useGetSingleCatalogQuery(catalogId ?? '', {
    skip: !catalogId
  })
  const { singleTariff } = useSelectedTariff(tariffId)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
    },
    {
      title: singleTariff ? singleTariff.description : '',
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs/${tariffId}/products`
    },
    {
      title: t`Tariff sales channels`,
      link: IS_HSL_SERVICE_ENVIRONMENT ? `${baseUrl}` : ''
    },
    {
      title: singleCatalog ? singleCatalog.name : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit sales channel`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        {singleCatalog && <TariffCatalogForm catalog={singleCatalog} successBaseUrl={baseUrl} />}
      </WithLoader>
    </Box>
  )
}

export default TariffCatalogEditPage
